import axios from "axios";

axios.interceptors.request.use(function (config) {
  if (window.localStorage.getItem('authorizationToken')) config.headers.Authorization = `Bearer ${window.localStorage.getItem('authorizationToken')}`;
  return config;
});

function errorRedirect(msg) {
  console.log('API Response Error:', msg);
}

export function Postdata(url, payload, config = {}) {
  console.log('payload: ', payload);
  console.log('url: ', url);

  let header = config;
  if (!("headers" in header)) {
    header = Object.assign({
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }, header);
    
  }

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, header)
      .then((response) => {
        // console.log("response123",response)
        response.data.message = (response.data.message == 'Authorization required') ? 'Under Development...' : response.data.message;
        if (["Unauthorized request", "You are already logged in on another device."].includes(response.data.message)||(response.data.status==400)) {
          setTimeout(()=>{
            console.log("window.location.href",window.location.href)
            window.location.href = '/';
          },800)
        }
        resolve(response.data);
      })
      .catch((e) => {
          e.message = (e.message == 'Network Error') ? 'Something went wrong!!!' : e.message;
        errorRedirect(e.message);
        reject(e);
      });
  });
}
